// extracted by mini-css-extract-plugin
export default {"movie":"ViewMovie_movie__kPZMQ"};